import {applyDecorators} from '@nestjs/common';
import {ApiProperty, ApiPropertyOptional, ApiPropertyOptions} from '@nestjs/swagger';
import {IsEnum, IsOptional} from 'class-validator';

import {INVALID_ENUM_VALUE} from '../constants';
import {BaseDecoratorOptions} from '../types';

type PropertyEnumParams<TValues> = BaseDecoratorOptions<TValues[keyof TValues]>;

export function ApiPropertyEnum<TValues extends object>(
  values: TValues,
  { isOptional, ...options }: PropertyEnumParams<TValues> = {},
): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = { enum: values, ...options };
  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsEnum(values, { message: INVALID_ENUM_VALUE, context: values }),
  );
}
